import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import PlaceBetServices from "../../services/PlaceBetServices";
import moment from "moment";
import "../../styles/ViewBetByQr.css";

const YANTRA_IMG_BASE = `${process.env.REACT_APP_NODE_URL}/api/yantra`;

function formatProfitLoss(pl) {
  if (!pl) return "—";
  if (pl.type === "PROFIT") return `+₹${Number(pl.value || 0).toFixed(2)}`;
  if (pl.type === "LOSS") return `-₹${Number(pl.value || 0).toFixed(2)}`;
  return "₹0.00";
}

const ViewBetByQr = () => {
  const { uid } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!uid) {
      setError("Invalid link");
      setLoading(false);
      return;
    }
    const api = new PlaceBetServices();
    api
      .getPlaceBetByUid(uid)
      .then((res) => {
        if (res?.isSuccess && res?.data) setDetail(res.data);
        else setError(res?.message || "Bet not found");
      })
      .catch((err) => {
        setError(err?.response?.data?.message || err?.message || "Failed to load bet details");
      })
      .finally(() => setLoading(false));
  }, [uid]);

  if (loading) {
    return (
      <div className="view-bet-qr view-bet-qr-loading">
        <div className="view-bet-qr-spinner" />
        <p>Loading bet details...</p>
      </div>
    );
  }

  if (error || !detail) {
    return (
      <div className="view-bet-qr view-bet-qr-error">
        <p className="view-bet-qr-err-msg">{error || "Bet not found"}</p>
        <button type="button" className="view-bet-qr-back" onClick={() => history.push("/")}>
          Go to Home
        </button>
      </div>
    );
  }

  const pbd = detail.place_bet_data || {};
  const user = detail.user || {};
  const session = detail.session || {};
  const yantraList = Array.isArray(pbd.yantra_list) ? pbd.yantra_list : [];
  const withBet = yantraList.filter((y) => Number(y.yantra_count) > 0);
  const winningYantraIds = detail.winning_yantra_ids || [];
  const winnerDetails = detail.winner_details || [];

  return (
    <div className="view-bet-qr">
      <header className="view-bet-qr-header">
        <h1 className="view-bet-qr-title">Place Bet Details</h1>
      </header>

      <div className="view-bet-qr-card">
        <section className="view-bet-qr-section">
          <h2 className="view-bet-qr-section-title">Profile</h2>
          <div className="view-bet-qr-row">
            <span>Name</span>
            <span>{user.user_name || "—"}[{user.user_username}]</span>
          </div>
          {/* <div className="view-bet-qr-row">
            <span>Reference ID</span>
            <span>{user.user_game_id || "—"}</span>
          </div> */}
          <div className="view-bet-qr-row">
            <span>Bet UID</span>
            <span className="view-bet-qr-uid">{detail.placebet_uid || "—"}</span>
          </div>
        </section>

        <section className="view-bet-qr-section">
          <h2 className="view-bet-qr-section-title">Session</h2>
          <div className="view-bet-qr-row">
            <span>Session</span>
            <span>{pbd.game_type || "—"}</span>
          </div>
          <div className="view-bet-qr-row">
            <span>Session #</span>
            <span>{session.session_no ?? "—"}</span>
          </div>
          <div className="view-bet-qr-row">
            <span>Draw Time</span>
            <span>{pbd.draw_time || "—"}</span>
          </div>
          <div className="view-bet-qr-row">
            <span>Created</span>
            <span>
              {pbd.created_at ? moment(pbd.created_at).format("DD-MM-YYYY HH:mm") : "—"}
            </span>
          </div>
        </section>

        <section className="view-bet-qr-section">
          <h2 className="view-bet-qr-section-title">Yantra (Buy with Amount)</h2>
          {withBet.length === 0 ? (
            <p className="view-bet-qr-empty">No yantra bets</p>
          ) : (
            <ul className="view-bet-qr-yantra-list">
              {withBet.map((y, idx) => {
                const count = Number(y.yantra_count) || 0;
                const amt = Number(y.yantra_amount) || 0;
                const total = count * amt;
                const isWin = winningYantraIds.includes(Number(y.yantra_id));
                return (
                  <li key={idx} className={`view-bet-qr-yantra-item ${isWin ? "view-bet-qr-yantra-win" : ""}`}>
                    <div className="view-bet-qr-yantra-main">
                      {y.yantra_img && (
                        <img
                          src={`${YANTRA_IMG_BASE}/${y.yantra_img}`}
                          alt=""
                          className="view-bet-qr-yantra-img"
                        />
                      )}
                      <span className="view-bet-qr-yantra-name">{y.yantra_name || `Yantra ${y.yantra_id}`}</span>
                    </div>
                    <div className="view-bet-qr-yantra-meta">
                      <span>{count} × ₹{amt.toFixed(2)}</span>
                      <span className="view-bet-qr-yantra-total">₹{total.toFixed(2)}</span>
                      {isWin && <span className="view-bet-qr-yantra-badge">Win</span>}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </section>

        <section className="view-bet-qr-section view-bet-qr-totals">
          <div className="view-bet-qr-row view-bet-qr-row-total">
            <span>Total Bet</span>
            <span>{pbd.total_bet ?? "—"}</span>
          </div>
          <div className="view-bet-qr-row view-bet-qr-row-total">
            <span>Grand Total (Amount)</span>
            <span>₹{Number(pbd.amount || 0).toFixed(2)}</span>
          </div>
        </section>

        {(detail.winning_amount != null || (detail.profit_or_loss && detail.profit_or_loss.type)) && (
          <section className="view-bet-qr-section view-bet-qr-result">
            <h2 className="view-bet-qr-section-title">Result</h2>
            {session.winner_yantra != null && session.winner_yantra !== "" && (
              <div className="view-bet-qr-row">
                <span>Win Yantra</span>
                <span>
                  {winnerDetails.length > 0
                    ? winnerDetails.map((wd) => wd.yantra_name).filter(Boolean).join(", ") || session.winner_yantra
                    : session.winner_yantra}
                </span>
              </div>
            )}
            <div className="view-bet-qr-row">
              <span>Winning Amount</span>
              <span>₹{Number(detail.winning_amount || 0).toFixed(2)}</span>
            </div>
            <div className="view-bet-qr-row">
              <span>Profit / Loss</span>
              <span
                className={
                  detail.profit_or_loss?.type === "PROFIT"
                    ? "view-bet-qr-profit"
                    : detail.profit_or_loss?.type === "LOSS"
                      ? "view-bet-qr-loss"
                      : ""
                }
              >
                {formatProfitLoss(detail.profit_or_loss)}
              </span>
            </div>
          </section>
        )}

        <section className="view-bet-qr-section all-yantra-list-section">
          <h2 className="view-bet-qr-section-title">Yantra List</h2>
          {yantraList.length === 0 ? (
            <p className="view-bet-qr-empty">No yantra data</p>
          ) : (
            <ul className="all-yantra-list">
              {yantraList.map((y, idx) => {
                const count = Number(y.yantra_count) || 0;
                const amt = Number(y.yantra_amount) || 0;
                const total = count * amt;
                const isWin = winningYantraIds.includes(Number(y.yantra_id));
                return (
                  <li key={idx} className={`all-yantra-list-item ${isWin ? "all-yantra-list-item-win" : ""}`}>
                    {y.yantra_img && (
                      <img
                        src={`${YANTRA_IMG_BASE}/${y.yantra_img}`}
                        alt=""
                        className="all-yantra-list-img"
                      />
                    )}
                    <span className="all-yantra-list-name">{y.yantra_name || `Yantra ${y.yantra_id}`}</span>
                    <span className="all-yantra-list-multi">
                      {amt} x {count}
                    </span>
                    <span className="all-yantra-list-amount">₹{total.toFixed(0)}</span>
                    {isWin && <span className="all-yantra-list-badge">Win</span>}
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
};

export default ViewBetByQr;
